export const COLOR = {
  blue: "#2caeba",
  purple: "#5d62b5",
  red: "#f2726f",
  yellow: "#ffc533",
  brown: "#8d6e63",
};
